import React, {useEffect, useState} from "react";
import VriContainer from "./vri/VriContainer";
import AcContainer from "./app-center/AcContainer";
import {getPreferredACPaymentMethod, getPreferredVDSPaymentMethod, handleError} from "../../helpers/helpers";
import {loadSettings} from "../../api/requests";
import {ServerResponse} from "../../models/models";
import {RESPONSE_TYPES, SUBSCRIPTION_ROOT_PAGES, VDS_LEVEL, VRI_LEVEL} from "../../constants";
import Loading from "../common/Loading";
import ResponseCard from "../common/cards/ResponseCard";
import VdsContainer from "./vds/VdsContainer";
import HomeContainer from "./home/HomeContainer";
import SubscriptionsContainerDataRefreshManager from "./SubscriptionsContainerDataRefreshManager";

const SubscriptionsContainer = () => {
    const [serverResponse, setServerResponse] = useState(new ServerResponse());
    const [loading, setLoading] = useState(true);
    const [appCenterData, setAppCenterData] = useState(null);
    const [vriData, setVriData] = useState(null);
    const [vdsData, setVdsData] = useState(null);
    const [settings, setSettings] = useState(null);
    const [rootPage, setRootPage] = useState(SUBSCRIPTION_ROOT_PAGES.HOME);

    const [shouldRefresh, setShouldRefresh] = useState(false);

    const { allPaymentMethods } = appCenterData || {};
    const [preferredACPaymentMethod, setPreferredACPaymentMethod] = useState(getPreferredACPaymentMethod(allPaymentMethods));
    const [preferredVDSPaymentMethod, setPreferredVDSPaymentMethod] = useState(getPreferredVDSPaymentMethod(allPaymentMethods));
    const [preferredVRIPaymentMethod, setPreferredVRIPaymentMethod] = useState(getPreferredVDSPaymentMethod(allPaymentMethods));

    if (serverResponse.type !== RESPONSE_TYPES.none) {
        return (
            <ResponseCard response={serverResponse}/>
        );
    }

    return (
        <div data-testid={'subscriptionsContainer'}>
            <Loading show={loading}/>
            <SubscriptionsContainerDataRefreshManager
                shouldRefresh={shouldRefresh}
                setSettings={setSettings}
                setAppCenterData={setAppCenterData}
                setServerResponse={setServerResponse}
                setPreferredACPaymentMethod={setPreferredACPaymentMethod}
                setPreferredVDSPaymentMethod={setPreferredVDSPaymentMethod}
                setPreferredVRIPaymentMethod={setPreferredVRIPaymentMethod}
                setVriData={setVriData}
                setVdsData={setVdsData}
                setLoading={setLoading}/>

            <div className={'row'}>
                <div className={'col-12'}>
                    <HomeContainer rootPage={rootPage}
                                   appCenterData={appCenterData}
                                   vriData={vriData}
                                   vdsData={vdsData}
                                   setRootPage={setRootPage}
                                   settings={settings}/>

                    <AcContainer data={appCenterData}
                                 setData={setAppCenterData}
                                 rootPage={rootPage}
                                 settings={settings}
                                 setRootPage={setRootPage}
                                 setServerResponse={setServerResponse}
                                 setShouldRefresh={setShouldRefresh}
                                 preferredACPaymentMethod={preferredACPaymentMethod}
                                 handleError={handleError}/>
                    <VriContainer
                        appData={appCenterData}
                        data={vriData}
                        setData={setVriData}
                        settings={settings}
                        rootPage={rootPage}
                        handleError={handleError}
                        setRootPage={setRootPage}
                        setServerResponse={setServerResponse}
                        setShouldRefresh={setShouldRefresh}
                        preferredVRIPaymentMethod={preferredVRIPaymentMethod}/>
                    <VdsContainer
                        appData={appCenterData}
                        data={vdsData}
                        setData={setVdsData}
                        settings={settings}
                        rootPage={rootPage}
                        handleError={handleError}
                        setRootPage={setRootPage}
                        setServerResponse={setServerResponse}
                        setShouldRefresh={setShouldRefresh}
                        preferredVDSPaymentMethod={preferredVDSPaymentMethod}/>
                </div>
            </div>
        </div>
    );
}

export default SubscriptionsContainer;